module.exports = __webpack_public_path__ + "img/not-for-profit.4d888da.svg";